<template>
  <order-body :isOk="false" :codeStatus="100" :pageText="'orderWait'">
  </order-body>
</template>
<script>
import orderBody from "_my/order-body";
export default {
  name: "orderWait",
  components: {
    orderBody,
  },
};
</script>
